<div class="flex flex-wrap md:flex-nowrap flex-row gap-8 items-center z-10 mb-12 md:mb-24">
  <div class="relative w-full hidden md:flex md:w-1/2 lg:w-[calc((100%-550px)/2)] flex-col justify-end pr-5 sm:pr-0">
    <div class="flex justify-start relative">
      <div class="grid grid-cols-2 relative gap-8 mb-8">
        <picture>
          <source [srcset]="assetsPath + 'thomas-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'thomas-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'thomas-quick-off.jpg'" alt="" />
        </picture>
        <picture>
          <source [srcset]="assetsPath + 'fernanda-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'fernanda-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'fernanda-quick-off.jpg'" alt="" />
        </picture>
      </div>
    </div>
    <div class="flex justify-start relative">
      <div class="grid grid-cols-2 relative gap-8 mb-8 right-8">
        <picture>
          <source [srcset]="assetsPath + 'hugo-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'hugo-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'hugo-quick-off.jpg'" alt="" />
        </picture>
        <div class="rounded-3xl px-4 flex justify-center items-center bg-qo-qomeet/20 text-3xl font-title font-bold" i18n>#formation</div>
      </div>
    </div>
  </div>
  <div class="w-full md:w-1/2 lg:w-[550px] mb-16 md:mb-0 px-4 md:pr-8 lg:pr-0">
    <h3 class="mb-6 text-3xl" i18n>Une équipe d'experts et des ressources en ligne à votre disposition</h3>
    <p class="mb-6 text-lg" i18n>Maximisez votre succès avec nos solutions logicielles et l'accompagnement de notre équipe d'experts événementiels. L'équipe Quick-Off vous guide à chaque étape, de la formation à la prise en main et l'utilisation quotidienne de nos solutions jusqu'au pilotage complet de votre programme bénévoles.</p>
    <p class="mb-6 text-lg" i18n>Accédez à l'académie et au centre d'aide, pour optimiser votre expérience former vos équipes et exploiter pleinement les avantages de nos solutions.</p>
    <a matRipple class="qo-MainRoundedBtn" [routerLink]="NavigationService.Routes.Contact()" i18n>Contactez-nous</a>
  </div>
  <div class="w-1/2 lg:w-[calc((100%-550px)/2)] hidden lg:block">
    <div class="flex justify-end relative">
      <div class="grid grid-cols-2 relative gap-8 mb-8 left-8">
        <div class="rounded-3xl px-4 flex justify-center items-center bg-qo-qoezion/20 text-3xl font-title font-bold" i18n>#pilotage</div>
        <picture>
          <source [srcset]="assetsPath + 'arnaud-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'arnaud-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'arnaud-quick-off.jpg'" alt="" />
        </picture>
      </div>
    </div>
    <div class="flex justify-end relative">
      <div class="grid grid-cols-2 relative gap-8 mb-8">
        <picture>
          <source [srcset]="assetsPath + 'cecile-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'cecile-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'cecile-quick-off.jpg'" alt="" />
        </picture>
        <picture>
          <source [srcset]="assetsPath + 'maxime-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'maxime-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'maxime-quick-off.jpg'" alt="" />
        </picture>
      </div>
    </div>
  </div>
  <div class="w-full md:hidden">
    <div class="flex relative justify-start">
      <div class="grid grid-cols-2 sm:grid-cols-3 relative gap-8 mb-8 justify-end right-8">
        <picture class="hidden sm:block">
          <source [srcset]="assetsPath + 'thomas-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'thomas-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'thomas-quick-off.jpg'" alt="" />
        </picture>
        <picture>
          <source [srcset]="assetsPath + 'fernanda-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'fernanda-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'fernanda-quick-off.jpg'" alt="" />
        </picture>
        <div class="rounded-3xl px-4 flex justify-center items-center bg-qo-qoezion/20 text-2xl sm:text-3xl font-title font-bold" i18n>#pilotage</div>
      </div>
    </div>
    <div class="flex relative justify-end">
      <div class="grid grid-cols-2 sm:grid-cols-3 relative gap-8 mb-8 justify-end left-8">
        <div class="rounded-3xl px-4 flex justify-center items-center bg-qo-qomeet/20 text-2xl sm:text-3xl font-title font-bold" i18n>#formation</div>
        <picture>
          <source [srcset]="assetsPath + 'hugo-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'hugo-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'hugo-quick-off.jpg'" alt="" />
        </picture>
        <picture class="hidden sm:block">
          <source [srcset]="assetsPath + 'arnaud-quick-off.webp'" type="image/webp">
          <source [srcset]="assetsPath + 'arnaud-quick-off.jpg'" type="image/jpg">
          <img class="rounded-3xl" [src]="assetsPath + 'arnaud-quick-off.jpg'" alt="" />
        </picture>
      </div>
    </div>
  </div>
</div>